<template>
  <div>
    <b-row>

      <b-col md="6" xl="8" v-if="vehicule">
        <b-card title="Canaux et prix d'annonce">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group label="Votre prix d'annonce TTC">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox
                          v-model="canaux_prix_annonce.is_canal_vente_particulier_actif"
                          :disabled="!canChangePrice"
                      />
                    </b-input-group-prepend>
                    <cleave
                        id="number"
                        :disabled="!canChangePrice || !canaux_prix_annonce.is_canal_vente_particulier_actif"
                        v-model="canaux_prix_annonce.prix_vente_particulier_ttc"
                        class="form-control"
                        :raw="true"
                        :options="{ numeral: true }"
                        placeholder="10,000"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Prix marchands TTC">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox
                          v-model="canaux_prix_annonce.is_canal_vente_marchand_actif"
                          :disabled="!canChangePrice"
                      >
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <cleave
                        id="number"
                        :disabled="!canChangePrice || !canaux_prix_annonce.is_canal_vente_marchand_actif"
                        v-model="canaux_prix_annonce.prix_vente_marchand_ttc"
                        class="form-control"
                        :raw="true"
                        :options="{ numeral: true }"
                        placeholder="10,000"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>


              <!-- submit and reset -->
              <b-col>
                <b-button
                    @click="submit"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    :disabled="!canChangePrice"
                >
                  Enregistrer
                </b-button>
                <small v-if="!canChangePrice" class="text-danger fw-bold d-block mt-1">
  Vous n'avez pas la permission de modifier le prix.
</small>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-col md="6" xl="4">
        <vehicule-la-cote :vehicule-id="vehicule.id"></vehicule-la-cote>

      </b-col>
    </b-row>


  </div>
</template>

<script>
import VehiculeLaCote from "@/components/Vehicule/VehiculeLaCote";

export default {
  name: "CanauxPrixAnnonceFrom",
  components: {VehiculeLaCote},
  props: {
    vehicule: {
      required: true,
      default: {}
    },
    context: {
      type: String,
      default: 'stock',
      validator: v => ['stock', 'catalogue'].includes(v)
    }
  },
  data() {
    return {
      canaux_prix_annonce: {
        prix_vente_particulier_ttc: 0,
        prix_vente_marchand_ttc: 0,
        is_canal_vente_particulier_actif: true,
        is_canal_vente_marchand_actif: false,
      }
    }
  },
  computed: {
    canChangePrice() {
      return this.context === 'catalogue'
        ? this.$can('changement-prix-catalogue', 'catalogue')
        : this.$can('changement-prix-stock', 'stock');
    }
  },
  created() {
    if (this.vehicule) {
      this.canaux_prix_annonce = {...this.vehicule.canaux_prix_annonce};
    }
  },
  methods: {
    submit() {
      let _this = this;
      this.$store.dispatch('gestionStockModule/updateCanauxPrixAnnonce', {
        vehicule_id: this.vehicule.id,
        context: this.context,
        ...this.canaux_prix_annonce
      }).then(function(response){
        console.log(response);
        _this.$emit('update-vehicule', response.vehicule);
      });
    }
  }
}
</script>

<style scoped>

</style>